import * as React from 'react';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { ConditionalWrapper } from '@cian/conditional-component';
import { ArticleHeading1, UIText1 } from '@cian/ui-kit/typography';
import { Button } from '@cian/ui-kit/button';

import { BigTitle } from '../BigTitle';

import * as styles from './styles.css';

export interface IIntroProps {
  title: string;
  partnerIcon?: string;
  steps: string[];
  submitText: string;
  onSubmit(): void;
}

export function Intro({ title, partnerIcon, steps, submitText, onSubmit }: IIntroProps) {
  const isMobile = !useIsDesktop();

  return (
    <div className={styles['container']}>
      <div>
        {isMobile && <div className={styles['img']} />}
        {partnerIcon && <img className={styles['partner-icon']} src={partnerIcon} alt={title} />}
        <div className={styles['title']}>
          <ConditionalWrapper if={isMobile} ThenComponent={ArticleHeading1} ElseComponent={BigTitle}>
            <span>{title}</span>
          </ConditionalWrapper>
        </div>
        <ul className={styles['list']}>
          {steps.map((item, index) => (
            <li key={index} className={styles['list-item']}>
              <span className={styles['marker']}>
                <UIText1>{index + 1}</UIText1>
              </span>
              <UIText1>{item}</UIText1>
            </li>
          ))}
        </ul>
        <div className={styles['button-sticky']} data-testid="quizStart">
          <Button theme="fill_primary" size="M" onClick={onSubmit} fullWidth={isMobile}>
            {submitText}
          </Button>
        </div>
      </div>
    </div>
  );
}
